import { TranslationsRepository } from '../repositories/translations.repository';
import { Observable } from 'rxjs';
import { LanguageModel } from '../models/language.model';
import { UseCaseSync } from '@/core/base/use-case-sync';

export type LoaderTranslationsUseCaseInput = {
    lang: 'es' | 'en';
};

export class TranslationsGetLanguageUseCase
    implements UseCaseSync<never, LanguageModel>
{
    constructor(private readonly repository: TranslationsRepository) {}

    execute(): LanguageModel {
        return this.repository.getLanguague();
    }
}
